export default __webpack_public_path__ + "static/media/refresh.55382115.svg";